// COMMENT OUT WHEN EXPORTING
// import { createApp } from 'vue';
// import App from './App.vue';
// import store from './store';

// createApp(App)
//   .use(store)
//   .mount('#app');

// UNCOMMENT FOR NAVBAR EXPORT
import { NavBar } from './components/NavBar/NavBar'
import './components/NavBar/NavBar.scss'
import './components/NavBar/AccountDropdown.scss'
import './components/NavBar/Burger.scss'
import './components/NavBar/Launcher.scss'

export default NavBar
